module.exports = __webpack_public_path__ + "static/media/headerlogo.f1d5f553.png";